import React, { useEffect, useState } from "react";
import axios from "axios";
import Model from "components/common/Model";
import FeedBackModel from "./FeedBackModel";
import ReceiptPageView from "components/receiptPage/ReceiptPageView";
import { getApiUrl } from "util/apiUrl";
import usePublicPageScroll from "hooks/usePublicPageScroll";

export default function Receipt(props) {
  usePublicPageScroll();
  const receiptName = props.match?.params?.receiptname;
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [isOpenFeedBack, setIsOpenFeedback] = useState(false);
  const [email, setemail] = useState("");
  const [rating, setrating] = useState(0);
  const [walletLoading, setWalletLoading] = useState(false);
  const toggleFeedBack = () => setIsOpenFeedback(!isOpenFeedBack);

  useEffect(() => {
    if (!receiptName) {
      setLoadError("Receipt not found.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setLoadError(null);
    axios
      .post(`${getApiUrl()}user/receiptByName`, {
        receiptName
      })
      .then(res => {
        if (res.data?.status && res.data?.data) {
          setReceiptData(res.data.data);
        } else {
          setLoadError(res.data?.message || "Receipt not found.");
        }
      })
      .catch(error => {
        setLoadError(
          error.response?.data?.message || "Unable to load this receipt."
        );
      })
      .finally(() => setLoading(false));
  }, [receiptName]);

  const addToGoogleWallet = () => {
    setWalletLoading(true);
    axios
      .post(`${getApiUrl()}user/walletPass`, {
        receiptName
      })
      .then(res => {
        const saveUrl = res.data?.data?.saveUrl;
        if (saveUrl) window.open(saveUrl, "_blank", "noopener,noreferrer");
      })
      .catch(err => console.error("Wallet error", err))
      .finally(() => setWalletLoading(false));
  };

  if (loadError && !loading) {
    return (
      <ReceiptPageView
        receiptData={{
          storeName: "Green Till",
          receiptTagline: loadError
        }}
        loading={false}
      />
    );
  }

  return (
    <>
      <ReceiptPageView
        receiptData={receiptData}
        loading={loading}
        receiptName={receiptName}
        walletLoading={walletLoading}
        onWallet={addToGoogleWallet}
        onEmailSubmitted={value => setemail(value)}
        onRating={value => {
          setrating(value);
          toggleFeedBack();
        }}
      />
      <Model isOpen={isOpenFeedBack} toggle={toggleFeedBack}>
        <FeedBackModel
          toggle={toggleFeedBack}
          email={email}
          rating={rating}
          receiptId={receiptData?.receiptId}
        />
      </Model>
    </>
  );
}
